import { ProductCarouselCard } from '../ProductCarouselCard';
import { ProductCarouselSlide } from '../product-carousel.types';
import { cn } from '@workspace/lib';

interface ProductCarouselDesktopViewportProps {
  viewportRef: (node: HTMLElement | null) => void;
  slides: ProductCarouselSlide[];
  layoutOptions: 1 | 2;
}

export function ProductCarouselDesktopViewport({
  viewportRef,
  slides,
  layoutOptions,
}: ProductCarouselDesktopViewportProps) {
  return (
    <div className="relative w-full hidden md:block">
      <div className="overflow-hidden" ref={viewportRef}>
        <div className="flex md:flex-row touch-pan-y -ml-4 md:gap-0">
          {slides &&
            slides.map((item, idx) => {
              return (
                <div
                  key={`desktop-carousel-card-${idx}`}
                  className={cn('pl-4 shrink-0 grow-0', layoutOptions === 2 ? 'md:basis-1/2' : 'md:basis-full')}
                >
                  <ProductCarouselCard {...item} />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}
